import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { useGetStoreInfoByStoreId } from '@as-react/common-queries';
import { StorefrontFillIcon } from '@yonderland/andes-icons';
import { Box, Icon, LinkButton, Stack, Switch, TextAlpha, useIsClient } from '@yonderland/andes-react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { SELECTED_STORE_STORAGE_KEY } from '../../../constants/StorageKeysConstants';
import { analyticsActions } from '../../../redux/analytics/actions/AnalyticsActions.creators';
import { basketActions } from '../../../redux/basket/actions/BasketActions.creators';
import { listerActions } from '../../../redux/lister/actions/ListerActions.creators';
import LocalStorageUtil from '../../../util/LocalStorageUtil';
import { generateTestId } from '../../../util/TestUtil';
import ZendeskWidgetUtil from '../../../util/ZendeskWidgetUtil';
import { useProductListerContext } from '../context';
const TEST_ID = 'in-store-filter';
export const InStoreFilter = () => {
    const { urlState: { storeId: urlStoreId }, updateStoreId, updateInStoreFilter, inStoreFilter, } = useProductListerContext();
    const dispatch = useDispatch();
    const isClient = useIsClient();
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const { defaultRequestParams: { mainWebshop, language }, } = useAemConfig();
    const { data } = useGetStoreInfoByStoreId(mainWebshop, urlStoreId, { language }, undefined, {
        query: {
            enabled: isClient && !!urlStoreId && Number(urlStoreId) !== Number(inStoreFilter === null || inStoreFilter === void 0 ? void 0 : inStoreFilter.storeId),
        },
    });
    useEffect(() => {
        if (data) {
            updateInStoreFilter(data);
            // @TODO lister listerActions deprecation
            dispatch(listerActions.updateInStoreFilter(data));
            LocalStorageUtil.setItem(SELECTED_STORE_STORAGE_KEY, data);
        }
    }, [data, updateInStoreFilter]);
    const handleUpdateStoreId = () => {
        updateStoreId(inStoreFilter === null || inStoreFilter === void 0 ? void 0 : inStoreFilter.storeId);
        if (!(inStoreFilter === null || inStoreFilter === void 0 ? void 0 : inStoreFilter.storeId)) {
            dispatch(basketActions.createCCPopupOpenAction());
            dispatch(analyticsActions.storeFilterStarted());
        }
        else if (!urlStoreId) {
            dispatch(analyticsActions.storeFilterApplied());
        }
    };
    const handleOpenPopup = () => {
        dispatch(basketActions.createCCPopupOpenAction());
        dispatch(inStoreFilter ? analyticsActions.storeFilterModified() : analyticsActions.storeFilterStarted());
        ZendeskWidgetUtil.updateZIndex(1);
    };
    if (!isClient)
        return null;
    return (_jsx(Box, { padding: "3", backgroundColor: "quiet", borderRadius: "lg", testId: TEST_ID, children: _jsxs(Stack, { gap: "2", children: [_jsx(Box, { paddingBlockStart: "0.5", children: _jsx(Icon, { source: StorefrontFillIcon, size: "sm" }) }), _jsxs(Box, { flex: 1, children: [_jsx(TextAlpha, { color: "emphasised", strong: true, testId: generateTestId({ testId: TEST_ID, suffix: 'hint' }), children: t('product.lister.inStore.mobile.from') }), inStoreFilter && (_jsxs(TextAlpha, { as: "span", color: "neutral", strong: true, testId: generateTestId({ testId: TEST_ID, suffix: 'store-name' }), children: [inStoreFilter.storeName, ' '] })), _jsx(LinkButton, { onClick: handleOpenPopup, variant: "secondary", testId: generateTestId({ testId: TEST_ID, suffix: 'action' }), children: inStoreFilter ? t('product.lister.inStore.mobile.change') : t('product.lister.inStore.mobile.chooseStore') })] }), _jsx(Switch, { checked: !!urlStoreId, id: "in_store_filter", onChange: handleUpdateStoreId, testId: generateTestId({ testId: TEST_ID, suffix: 'switch' }) })] }) }));
};
